<template>
  <a-modal title="从知识点抽题" :visible="visible" @ok="handleOk" @cancel="visible = false">
    <a-divider>知识点</a-divider>
    <j-category-select v-model="knowleages" onlyLeaf treeCheckable hideNoneChildrenNode pcode="A07" multiple placeholder="请选择知识点" />
    <a-divider>抽题数量</a-divider>
    <span>易：</span><a-input-number type="number" :min="0" v-model="randomCounts[0]" style="width:200px"/>
    <br>
    <span>中：</span><a-input-number type="number" :min="0" v-model="randomCounts[1]" style="width:200px"/>
    <br>
    <span>难：</span><a-input-number type="number" :min="0" v-model="randomCounts[2]" style="width:200px"/>
    <br><br>
    <!-- TODO 限定题目类型 -->
    <p>总计：{{parseInt(randomCounts[0]) + parseInt(randomCounts[1]) + parseInt(randomCounts[2])}}道</p>

    <br><br>
    <a-alert message="注意，如果所选知识点下的题目分数不同，最终的试卷可能分数也不同"></a-alert>
  </a-modal>
</template>

<script>
import JCategorySelect from '@/components/jeecg/JCategorySelect'

export default {
  name: 'SelectKnowleageQuestionModal',
  components: {
    JCategorySelect,
  },
  data() {
    return {
      visible: false,
      knowleages: null,
      randomCounts: [0,0,0]
    }
  },
  created() {
  },
  methods: {
    handleOk() {
      this.$emit("ok", this.knowleages,this.randomCounts)
    },
  },
}
</script>

<style>
</style>